module.exports = __webpack_public_path__ + "img/private-icon.eba4874a.svg";